import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <main id="main-content" style={{ textAlign: 'center', padding: '120px 32px' }}>
      <SEO
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Return to elijahmoreno.com to explore research, teaching, and publications by Elijah Moreno."
        path="/404"
      />
      <h1 style={{ fontSize: '4rem', fontWeight: 700, marginBottom: '8px', color: 'var(--text-muted)' }}>404</h1>
      <p style={{ fontSize: '1.2rem', color: 'var(--text-secondary)', marginBottom: '24px' }}>
        This page doesn't exist.
      </p>
      <Link to="/" style={{ color: 'var(--color-trust)', fontWeight: 500 }}>
        Return home
      </Link>
    </main>
  );
}
